<template>
  <div class="container">
      <div class="card">

          <div class="subtitle">一、小号回收规则</div>
          <ul class="list">
              <li>仅支持回收<strong>90天内有消费记录</strong>且<strong>单笔实际支付满10元</strong>的小号。</li>
              <li><strong>实际支付界定</strong>：仅统计微信/支付宝/充值余额等现金充值（优惠券、赠送余额不计入）。</li>
              <li><strong>返还规则</strong>：按小号累计实际支付金额的<strong>5%</strong>，返还赠送余额至账户。</li>
              <li>返还的赠送余额<strong>仅限游戏内充值使用</strong>，<span class="warn">不支持提现、转账、兑换现金</span>。</li>
              <li><strong>操作须知</strong>：提交回收前请退出小号所有登录设备；提交后请勿再充值，否则损失自行承担。</li>
              <li><strong>回收范围</strong>：将回收小号内<strong>所有区服全部角色</strong>，回收成功后小号无法登录游戏。</li>
              <li><strong>特殊限制</strong>：游戏停运/停服、部分未开放回收的游戏小号不支持回收；具体以回收页面展示为准。</li>
          </ul>

          <div class="subtitle">二、小号赎回规则</div>
          <ul class="list">
              <li><strong>赎回时效</strong>：回收成功后<strong>24小时内</strong>可申请赎回，逾期通道自动关闭，无法赎回。</li>
              <li><strong>赎回方式</strong>：需消耗对应赠送余额；余额不足可使用充值余额补足差额。</li>
              <li><strong>疑问咨询</strong>：回收或赎回过程中如有疑问，请及时联系官方客服处理。</li>
          </ul>

          <!-- <div class="footer">0.01折手游 · 官方规则</div> -->
      </div>
  </div>
</template>

<style scoped="scoped">
  * {
      margin: 0;
      padding: 0;
      box-sizing: border-box;
      font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  }

  body {
      background-color: #ffffff;
      padding: 15px;
      color: #333;
      line-height: 1.65;
  }

  .container {
    padding: 0 32px;
  }

  /* .card {
      background: #fff;
      border-radius: 16px;
      padding: 22px 18px;
      box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  } */

  .title {
      text-align: center;
      font-size: 20px;
      font-weight: bold;
      color: #111;
      margin-bottom: 18px;
  }

  .subtitle {
      font-size: 32px;
      font-weight: bold;
      color: #00D9C5;
      margin: 36px 0 20px 0;
      padding-bottom: 16px;
      border-bottom: 2px solid #e6f7f5;
  }

  .list {
      padding-left: 12px;
      margin-top: 10px;
  }

  .list li {
      list-style: none;
      position: relative;
      padding-left: 36px;
      margin-bottom: 20px;
      font-size: 30px;
      color: #444;
  }

  .list li::before {
      content: "•";
      color: #00D9C5;
      font-weight: bold;
      position: absolute;
      left: 0;
      top: 0;
  }

  .warn {
      color: #ff4d4f;
      font-weight: 500;
  }

  .footer {
      text-align: center;
      font-size: 24px;
      color: #999;
      margin-top: 40px;
  }
</style>
